import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { View } from 'react-native';

import { routes } from 'utils/routing';

import { TermsLink } from './styled';

const Bullet = ({ label, value }: { label: string; value: string }) => (
  <View style={{ marginBottom: 8 }}>
    <Text variant="body" fontWeight="bold">
      • {label}{' '}
      <Text variant="body" fontWeight="normal">
        {value}
      </Text>
    </Text>
  </View>
);

export const DeliveryTermsCanada = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Text variant="headerThree" textAlign="center" mb="$4">
        {formatMessage({
          id: 'deliveryTerms.title.ca',
          defaultMessage: 'Delivery on the BK App and burgerking.ca',
        })}
      </Text>
      <Text variant="body" mb="$4">
        {formatMessage({
          id: 'deliveryTerms.intro.ca.part1',
          defaultMessage:
            'Delivery offered at participating Canadian restaurants on the BK App and burgerking.ca. Delivery powered by third-party delivery providers, and subject to availability and restaurant delivery hours.',
        })}
      </Text>
      <Text variant="body" mb="$4">
        {formatMessage({
          id: 'deliveryTerms.intro.ca.part2',
          defaultMessage:
            'Prices may be higher than at restaurants. Delivery order fees: Delivery Fee, Service Fee and Small Cart Fees may apply.',
        })}
      </Text>
      <Text variant="body" mb="$4">
        {formatMessage({
          id: 'deliveryTerms.intro.ca.part3',
          defaultMessage:
            'Print coupons not valid on delivery orders. Not all digital offers available on delivery. Check digital offer terms at burgerking.ca/rewards/offers before ordering.',
        })}
      </Text>

      <Text variant="headerThree" mb="$2">
        {formatMessage({
          id: 'deliveryTerms.ca.heading',
          defaultMessage: 'Canadian Delivery Fees:',
        })}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.fee.ca.lt12.label',
            defaultMessage: 'Delivery on Orders <$12:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.fee.ca.lt12.value',
            defaultMessage: '$2.99 Delivery Fee + 10% Service Fee + $1.99 Small Cart Fee',
          })}
        />
        <Bullet
          label={formatMessage({
            id: 'deliveryTerms.fee.ca.gte12.label',
            defaultMessage: 'Delivery on Orders ≥$12:',
          })}
          value={formatMessage({
            id: 'deliveryTerms.fee.ca.gte12.value',
            defaultMessage: '$2.99 Delivery Fee + 10% Service Fee',
          })}
        />
      </View>

      <TermsLink to={routes.mobileOrderTerms}>
        <Text variant="headerThree" mt="$4">
          {formatMessage({
            id: 'deliveryTerms.ca.mobileTitle',
            defaultMessage: 'Mobile Order and Payment Terms',
          })}
        </Text>
      </TermsLink>
    </>
  );
};
